import { Box } from "@mui/material";
import { ReactNode, useRef, useState } from "react";
import { ConfirmDeleteModal } from "@/components/commons/ConfirmDeleteModal";
import { ReportFilterTrigger } from "@/features/learning-progress/components/report/ReportFilterTrigger";

type RenderModalArgs<TForm> = {
  anchorEl: HTMLElement | null;
  onClose: () => void;
  onApplyFilters?: (filters: TForm) => void;
};

type Props<TForm> = {
  activeFilterCount: number;
  onApplyFilters?: (filters: TForm) => void;
  // Clearing is "apply with empty values" — keeps a single side-effect path with apply.
  clearValues: TForm;
  renderModal: (args: RenderModalArgs<TForm>) => ReactNode;
};

// TODO(IROHANA_STUDY_DEV-357): filter on hold per A.Umeda (Figma node 10562-45259) —
// will revisit alongside 外国人一覧 redesign. Flip to false and remove the early return below to re-enable.
const FEATURE_FLAG_DISABLED = true;

export function ReportFilterBar<TForm>({ activeFilterCount, onApplyFilters, clearValues, renderModal }: Props<TForm>) {
  const anchorRef = useRef<HTMLDivElement | null>(null);
  const [filterAnchorEl, setFilterAnchorEl] = useState<HTMLElement | null>(null);
  const [isClearConfirmOpen, setIsClearConfirmOpen] = useState(false);

  const handleClear = () => {
    onApplyFilters?.(clearValues);
    setIsClearConfirmOpen(false);
  };

  if (FEATURE_FLAG_DISABLED) {
    return null;
  }

  return (
    <>
      <Box ref={anchorRef} sx={{ display: "inline-flex" }}>
        <ReportFilterTrigger
          activeFilterCount={activeFilterCount}
          isOpen={Boolean(filterAnchorEl)}
          onOpen={() => setFilterAnchorEl(anchorRef.current)}
          onClickClear={() => setIsClearConfirmOpen(true)}
        />
      </Box>
      {renderModal({
        anchorEl: filterAnchorEl,
        onClose: () => setFilterAnchorEl(null),
        onApplyFilters,
      })}
      <ConfirmDeleteModal
        open={isClearConfirmOpen}
        onClose={() => setIsClearConfirmOpen(false)}
        onOk={handleClear}
        message="適用中のフィルタを解除しますがよろしいですか？"
        title=""
      />
    </>
  );
}
